module.exports = __webpack_public_path__ + "static/media/bright-logo.114e7058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bright-logo.png
// module id = 63
// module chunks = 0